import autoDeliveryDcxService from '@/services/autoDeliveryDcxService';

import AutoDeliveryStatusNoneDetailsPopup from './AutoDelivery/AutoDeliveryStatusNoneDetailsPopup';
import AutoDeliveryDcxStatusNoneDetailsPopup from './AutoDeliveryDcx/AutoDeliveryDcxStatusNoneDetailsPopup';

const AutoDeliveryStatusNoneDetailsPopupSwitcher = (props) => {
    const isDcx = autoDeliveryDcxService.getIsAutoDeliveryDcxEnabled();

    return isDcx ? (
        <AutoDeliveryDcxStatusNoneDetailsPopup {...props} />
    ) : (
        <AutoDeliveryStatusNoneDetailsPopup {...props} />
    );
};

export default AutoDeliveryStatusNoneDetailsPopupSwitcher;
